// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1QLph","container":"styles_container__2We9x","title":"styles_title__3TxTo","wrapper":"styles_wrapper__3N9Ez","answer":"styles_answer__3HqYr"};